import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SuggestedInsuranceIssuersMenu from './SuggestedInsuranceIssuersMenu';
import InsuranceIssuerSelectOption from './InsuranceIssuerSelectOption';

const insuranceIssuersDataShape = PropTypes.shape({
  loading: PropTypes.bool.isRequired,
  insuranceIssuers: PropTypes.shape({
    nodes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        display: PropTypes.string.isRequired,
        state: PropTypes.string,
      })
    ).isRequired,
  }),
  Combobox: PropTypes.elementType,
});

export default class GlobalInsuranceIssuerSelect extends Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    selectedItem: PropTypes.object,
    onChange: PropTypes.func,
    emptyLabel: PropTypes.string,
    defaultSelectedInsuranceIssuerData: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      insuranceIssuer: PropTypes.shape({
        id: PropTypes.string.isRequired,
        display: PropTypes.string.isRequired,
      }),
    }),
    autocompleteData: insuranceIssuersDataShape,
    featuredData: insuranceIssuersDataShape,
  };

  constructor(props) {
    super(props);
    this.triggerOnChangeFromDefaultSelectedValue(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.triggerOnChangeFromDefaultSelectedValue(props);
  }

  triggerOnChangeFromDefaultSelectedValue({
    selectedItem,
    onChange,
    defaultSelectedInsuranceIssuerData: data,
  }) {
    if (selectedItem != null || onChange == null || data == null || data.insuranceIssuer == null) {
      return;
    }
    onChange(data.insuranceIssuer);
  }

  renderMenu = (comboboxProps) => {
    const { autocompleteData, featuredData } = this.props;
    if (autocompleteData) {
      return this.renderSearchResults(comboboxProps);
    }
    if (featuredData) {
      return this.renderFeaturedIssuers(comboboxProps);
    }
    return null;
  };

  renderFeaturedIssuers(comboboxProps) {
    const {
      featuredData: { loading, error, insuranceIssuers },
      emptyLabel,
      ComboboxMessage,
      ComboboxSectionTitle,
      ComboboxOption,
    } = this.props;
    if (loading || error || (insuranceIssuers?.nodes && insuranceIssuers.nodes.length === 0)) {
      return null;
    }
    return (
      <SuggestedInsuranceIssuersMenu
        emptyLabel={emptyLabel}
        featuredInsuranceIssuers={insuranceIssuers && insuranceIssuers.nodes}
        comboboxProps={comboboxProps}
        ComboboxMessage={ComboboxMessage}
        ComboboxSectionTitle={ComboboxSectionTitle}
        ComboboxOption={ComboboxOption}
        showSearchLabel
      />
    );
  }

  renderSearchResults(comboboxProps) {
    const { ComboboxOption } = this.props;
    const {
      autocompleteData: { loading, error, insuranceIssuers },
    } = this.props;
    if (loading || error) {
      return null;
    }
    return insuranceIssuers.nodes.map((issuer, index) => (
      <InsuranceIssuerSelectOption
        key={issuer.id}
        item={issuer}
        index={index}
        ComboboxOption={ComboboxOption}
        {...comboboxProps}
      />
    ));
  }

  render() {
    const {
      defaultSelectedInsuranceIssuerData,
      autocompleteData,
      featuredData,
      Combobox,
    } = this.props;

    const loading =
      (defaultSelectedInsuranceIssuerData && defaultSelectedInsuranceIssuerData.loading) ||
      (autocompleteData && autocompleteData.loading) ||
      (featuredData && featuredData.loading);

    return (
      <Combobox loading={loading} {...this.props}>
        {this.renderMenu}
      </Combobox>
    );
  }
}
